export default __webpack_public_path__ + "static/media/shield.c959aa13.svg";